// extracted by mini-css-extract-plugin
export default {"aside_pharmacy_navbar":"SpecialtySideBar_aside_pharmacy_navbar__wOYrG"};